export const createDeleteImagemForm = id => `deleteImageForm${id}`;